import * as React from 'react'
import { ReactElement } from 'react'
import { ActionButton, ISearchBoxProps, MessageBar, SearchBox, Stack, Text } from '@fluentui/react'
import Tooltip from '../../../components/Tooltip'
import useHost from '../../../hooks/useHost'
import useAxios from '../../../hooks/useAxios'
import { useTranslation } from 'react-i18next'
import { isOfficeInitialized } from '../../../helpers/outlookHelper'
import { isAppContext } from '../../../helpers/appHelper'
import { AppContext } from '../../../config/appConfig'

type Props = Partial<ISearchBoxProps> & {
    setAllowedMessageIds: (ids?: string[]) => void
    reference: string
    setIsLoading: (isLoading: boolean) => void
}

type SearchMessageResponse = {
    ids: string[]
    immutableIds: string[]
}

function SearchTooltip(): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <Stack tokens={{ childrenGap: 's1' }}>
            <Text variant="mediumPlus">{translate('email.search.tooltip.title')}</Text>
            <MessageBar>{translate('email.search.tooltip.subtitle')}</MessageBar>
            <ActionButton iconProps={{ iconName: 'OpenInNewWindow' }} onClick={() => window.open(process.env.SEARCH_CONDITIONS_URL, '_blank')}>
                {translate('email.search.tooltip.content')}
            </ActionButton>
        </Stack>
    )
}

export default function EmailSearchBox(props: Props): ReactElement {
    const axios = useAxios()
    const { RowKey: hostKey } = useHost()
    const { t: translate } = useTranslation()

    return (
        <Tooltip display="block" hostProps={{ content: <SearchTooltip /> }}>
            <SearchBox
                placeholder={translate('email.search.placeholder')}
                autoFocus={!isOfficeInitialized() || !isAppContext([AppContext.Compose])}
                underlined
                {...props}
                onChange={(_, query) => {
                    if ((query || '').trim().length === 0) {
                        props.setAllowedMessageIds(undefined)
                    }
                }}
                onSearch={query => {
                    props.onSearch(query)
                    axios
                        .post<SearchMessageResponse>(
                            '/api/search-messages/',
                            { query, hostKey, reference: props.reference },
                            { baseURL: process.env.INBOXER_HOST },
                        )
                        .then(result => props.setAllowedMessageIds(result.data.immutableIds))
                        .finally(() => props.setIsLoading(false))
                }}
            />
        </Tooltip>
    )
}
